export const AUTHENTICATE_BASE_URL = '/account';
